import { h } from 'preact'

const UnreadByTeam = () =>
  ({ newRepliesSinceLastModeration } : { newRepliesSinceLastModeration: number }) =>
    newRepliesSinceLastModeration > 0 &&
      <div class='overview__unread-by-team'>+ { newRepliesSinceLastModeration } Replies</div>

export default UnreadByTeam
